import { gql } from "@apollo/client";

const legacyTermSheetAssignmentsFields = `
  id
  archetype
  averageCapacity
  buyingBasePrice
  buyingCurrency
  buyingAmount
  sellingBasePrice
  sellingDiscount
  sellingCurrency
  marginPercentage
  marginAmount
  commissionPercentage
  commissionAmount
  onboardedAt
  offboardedAt
  profile {
    uuid
    slug
    name
    firstName
    lastName
    avatarUrl
    archetype
    location
  }
`;

const legacyTermSheetFields = `
  id
  name
  type
  state
  createdAt
  versionId
  teamSize
  versionNumber
  organizationBillingAccount {
    id
    currencyCode
  }
  assignments {
    ${legacyTermSheetAssignmentsFields}
  }
`;

const LEGACY_TERM_SHEET_FIELDS = gql`
  fragment LegacyTermSheetFields on LegacyTermSheet {
    ${legacyTermSheetFields}
  }
`;

const LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS = gql`
  fragment LegacyTermSheetAssignmentFields on Assignment {
    ${legacyTermSheetAssignmentsFields}
  }
`;

export { LEGACY_TERM_SHEET_FIELDS, LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS };
